import {Routes} from '@angular/router';

export const CommonLayout_ROUTES: Routes = [

  // Dashboard
  {
    path: 'dashboard',
    loadChildren: () => import('../../modules/dashboard/dashboard.module').then(m => m.DashboardModule),
  },
  {
    path: 'accounts',
    loadChildren: () => import('../../modules/account/account.module').then(m => m.AccountModule),
  },
  {
    path: 'users',
    loadChildren: () => import('../../modules/users/users.module').then(m => m.UsersModule)
  },
  {
    path: 'life-hero',
    loadChildren: () => import('../../modules/life-hero/life-hero.module').then(m => m.LifeHeroModule)
  },
  // Pages
  {
    path: 'pages',
    data: {
      title: 'Pages '
    },
    children: [
      {
        path: '',
        redirectTo: '/transaction',
        pathMatch: 'full'
      },
      {
        path: '',
        loadChildren: () => import('../../pages/pages.module').then(m => m.PagesModule)
      },
    ]
  },
];
